import type React from 'react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { LandingSkeleton } from '../components';
import { useBfcacheGuard } from '../hooks';
import useAuthTransition from '../hooks/useAuthTransition';
import usePostAuthRedirect from '../hooks/usePostAuthRedirect';
import { initializeImageOptimization } from '../utils/imageOptimization';

const AuthReadyGate: React.FC = () => {
  const { isTransitioning, showSkeleton } = useAuthTransition();

  useBfcacheGuard();
  usePostAuthRedirect();

  useEffect(() => {
    initializeImageOptimization().catch((error) => {
      console.warn('Failed to initialize image optimization:', error);
    });
  }, []);

  if (isTransitioning) {
    return showSkeleton ? <LandingSkeleton /> : <div className="auth-transition-placeholder" />;
  }

  return <Outlet />;
};

export default AuthReadyGate;
